import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=d316248e&scoped=true&"
import script from "./Department.vue?vue&type=script&lang=js&"
export * from "./Department.vue?vue&type=script&lang=js&"
import style1 from "./Department.vue?vue&type=style&index=1&id=d316248e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d316248e",
  null
  
)

export default component.exports